import { Children } from "react";
import "./Application.css";

export function Application({
    children,
    pid,
    title,
    icon,
    posX,
    posY,
    width,
    height,
    zIndex,
    isMaximized,
    isMinimized,
    isMoving,
    isResizing,
    isFocused,
    isClosing,
    isTransitioning,
    language,
    onFocusFunc,
    onCloseFunc,
    onMinimizeFunc,
    onMaximizeFunc,
    onStartDragFunc,
    onEndDragFunc,
    onStartResizeFunc,
    onEndResizeFunc,
    onMouseMoveFunc,
}) {
    return (
        <div
            className={`application ${
                isTransitioning
                    ? "application_transition"
                    : "application_no-transition"
            } ${
                isMaximized
                    ? "application_maximized"
                    : "application_no-maximized"
            } ${isClosing ? "application_closing" : ""}`}
            style={{
                left: isMinimized ? "50%" : isMaximized ? "0" : `${posX}px`,
                top: isMinimized
                    ? "calc(100vh - 50px)"
                    : isMaximized
                    ? "0"
                    : `${posY}px`,
                width: isMinimized ? "0" : isMaximized ? "100%" : `${width}px`,
                height: isMinimized
                    ? "0"
                    : isMaximized
                    ? "calc(100% - 61px)"
                    : `${height}px`,
                zIndex: zIndex,
                backgroundColor: isFocused ? "#00183420" : "transparent",
            }}
            key={pid}
            onMouseDown={() => onFocusFunc(pid)}
            onMouseMove={(e) => {
                if (isMoving || isResizing) {
                    onMouseMoveFunc(e);
                }
            }}
            onMouseUp={(e) => {
                if (isMoving) {
                    onEndDragFunc(e, pid);
                } else if (isResizing) {
                    onEndResizeFunc(e, pid);
                }
            }}
            onTouchStart={() => onFocusFunc(pid)}
            onTouchMove={(e) => {
                if (isMoving || isResizing) {
                    const eventConverted = {
                        clientX: e.touches[0].clientX,
                        clientY: e.touches[0].clientY,
                        target: e.target,
                        currentTarget: e.currentTarget,
                        preventDefault: e.preventDefault.bind(e),
                        stopPropagation: e.stopPropagation.bind(e),
                        stopImmediatePropagation:
                            e.stopImmediatePropagation.bind(e),
                    };

                    onMouseMoveFunc(eventConverted);
                }
            }}
            onTouchEnd={(e) => {
                if (isMoving) {
                    onEndDragFunc(e, pid);
                } else if (isResizing) {
                    onEndResizeFunc(e, pid);
                }
            }}
        >
            <div
                className="application_corner application_corner_top_left"
                onMouseDown={(e) => {
                    onStartResizeFunc("top-left")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("top-left")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div
                className="application_horizontal_line application_horizontal_line_top"
                onMouseDown={(e) => {
                    onStartResizeFunc("top")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("top")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div
                className="application_corner application_corner_top_right"
                onMouseDown={(e) => {
                    onStartResizeFunc("top-right")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("top-right")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div
                className="application_vertical_line application_vertical_line_left"
                onMouseDown={(e) => {
                    onStartResizeFunc("left")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("left")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div className="application_container">
                <div
                    className="application_header"
                    onMouseDown={(e) => {
                        onStartDragFunc(e);
                    }}
                    onMouseUp={(e) => {
                        onEndDragFunc(e);
                    }}
                    onDoubleClick={() => onMaximizeFunc(pid)}
                    onTouchStart={(e) => {
                        onStartDragFunc(e);
                    }}
                    onTouchEnd={(e) => {
                        onEndDragFunc(e);
                    }}
                >
                    <img
                        className="application_icon"
                        src={icon}
                        alt="Application Icon"
                    />
                    <span className="application_title">{title[language]}</span>
                    <div className="application_buttons">
                        <button
                            className="application_button application_button_minimize"
                            onClick={onMinimizeFunc}
                        >
                            _
                        </button>
                        <button
                            className="application_button application_button_maximize"
                            onClick={onMaximizeFunc}
                        >
                            □
                        </button>
                        <button
                            className="application_button application_button_close"
                            onClick={onCloseFunc}
                        >
                            X
                        </button>
                    </div>
                </div>
                <div className="application_body">
                    {children ? (
                        Children.map(children, (child) => {
                            return child;
                        })
                    ) : (
                        <div className="application_empty">No content</div>
                    )}
                </div>
            </div>
            <div
                className="application_vertical_line application_vertical_line_right"
                onMouseDown={(e) => {
                    onStartResizeFunc("right")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("right")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div
                className="application_corner application_corner_bottom_left"
                onMouseDown={(e) => {
                    onStartResizeFunc("bottom-left")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("bottom-left")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div
                className="application_horizontal_line application_horizontal_line_bottom"
                onMouseDown={(e) => {
                    onStartResizeFunc("bottom")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("bottom")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
            <div
                className="application_corner application_corner_bottom_right"
                onMouseDown={(e) => {
                    onStartResizeFunc("bottom-right")(e);
                }}
                onMouseUp={(e) => {
                    onEndResizeFunc(e);
                }}
                onTouchStart={(e) => {
                    onStartResizeFunc("bottom-right")(e);
                }}
                onTouchEnd={(e) => {
                    onEndResizeFunc(e);
                }}
            ></div>
        </div>
    );
}
